import request from '@/service/index'
import qs from 'qs'

export const getContentList = (params: any) => {
  return request({
    url: '/cms/getArticleList',
    method: 'GET',
    params
  })
}

export const getContentTypeList = () => {
  return request({
    url: '/cms/getArticleClassList',
    method: 'GET'
  })
}

export const deleteContent = (params: any) => {
  return request({
    url: '/cms/deleteArticle',
    method: 'GET',
    params
  })
}

export const getNoticeContent = (params: any) => {
  return request({
    url: '/cms/getArticle',
    method: 'GET',
    params
  })
}

export const submitContentData = (data: any) => {
  return request({
    url: '/cms/saveArticle',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export const getFeedbackList = (params: any) => {
  return request({
    url: '/cms/getFeedbackList',
    method: 'GET',
    params
  })
}

export const deleteFeedback = (params: any) => {
  return request({
    url: '/cms/deleteFeedback',
    method: 'GET',
    params
  })
}

export const getFeedbackContent = (params: any) => {
  return request({
    url: '/cms/getFeedback',
    method: 'GET',
    params
  })
}

export const uploadImg = (data: any) => {
  return request({
    url: '/cms/UploadFile',
    method: 'POST',
    data
  })
}
